var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMysafetyActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#008CFF",
    rx: 2.466
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0874CE",
    d: "M17.753 0h15.781A2.466 2.466 0 0136 2.466v31.068A2.466 2.466 0 0133.534 36h-15.78V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.82 6.411v.012c3.145 1.62 6.84 2.399 9.93 2.618v9.191c0 2.453-.234 4.204-1.43 5.898-1.44 2.04-4.234 3.961-8.523 5.856l.022-.01.001.01-.011-.005-.012.005v-.01c-4.266-1.891-7.047-3.81-8.48-5.846-1.193-1.694-1.427-3.445-1.427-5.898V9.04c3.093-.22 6.789-1.001 9.93-2.629l-.024.012.001-.012.012.006.011-.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M16.318 18.863l-2.572-2.569-1.417 1.415 3.989 3.99 1.26-1.258 5.705-5.709-1.415-1.417-4.29 4.29z"
  }))));
}
export default SvgMysafetyActive;